

class CommonConstants {

    // Legacy Web UI router
    /**
     * @deprecated
     */
    public static getWebApiV1Prefix()   {
        // return "/be/api/v1";
        return "/web/api/v1";
    }

    // API V2 for WEB REST
    /**
     * @deprecated
     */
    public static getWebApiV2Prefix()   {
        // return "/be/v2/web";
        return "/web/api/v2";
    }

    // API V2 for Devices >= 6.0.0
    /**
     * @deprecated
     */
    public static getDeviceApiV2Prefix()   {
        return "/api/v2/device";
    }

    // API V1 for device-control REST - External usage
    /**
     * @deprecated
     */
    public static getDeviceControlRestApiV1Prefix()   {
        return "/rest/v1/device-control";
    }

}


export default CommonConstants;
